<template>
  <div class="step-welcome">
    <div class="step-welcome__logo">🌱</div>
    <h1 class="step-welcome__headline">Let's set up your garden</h1>
    <p class="step-welcome__sub">Takes about 2 minutes.</p>

    <div class="step-welcome__chips">
      <div class="step-welcome__chip">
        <span class="chip-icon">📋</span>
        <span class="chip-label">Track<br>your plot</span>
      </div>
      <div class="step-welcome__chip">
        <span class="chip-icon">🗓</span>
        <span class="chip-label">Plan<br>your year</span>
      </div>
      <div class="step-welcome__chip">
        <span class="chip-icon">🤖</span>
        <span class="chip-label">Grow<br>smarter</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepWelcome',
}
</script>

<style scoped>
.step-welcome {
  text-align: center;
  padding: 12px 0 8px;
}
.step-welcome__logo {
  font-size: 3rem;
  margin-bottom: 12px;
}
.step-welcome__headline {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a3a2a;
  margin-bottom: 6px;
}
.step-welcome__sub {
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 28px;
}
.step-welcome__chips {
  display: flex;
  gap: 12px;
  justify-content: center;
}
.step-welcome__chip {
  flex: 1;
  max-width: 120px;
  border: 1.5px solid #e0e0d8;
  border-radius: 10px;
  padding: 14px 8px;
  background: #fafaf8;
}
.chip-icon {
  font-size: 1.5rem;
  display: block;
  margin-bottom: 6px;
}
.chip-label {
  font-size: 0.8rem;
  color: #444;
  line-height: 1.3;
}
</style>
